<div class="p-4 md:p-6 max-w-6xl mx-auto">

  <!-- Header -->
  <div class="mb-6">
    <h1 class="text-2xl font-bold text-gray-800 flex items-center">
      <mat-icon style="color: #1C593D; margin-right: 8px;">currency_exchange</mat-icon>
      Administrador de Tasas
    </h1>
    <p style="color: #6b7280; font-size: 0.85rem; margin-top: 4px;">
      Gestiona las tasas de cambio desde diferentes fuentes.
    </p>
  </div>

  <!-- Tabs -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 6px; font-size: 20px; width: 20px; height: 20px;">edit</mat-icon>
          Manual
        </ng-template>
        <ng-template matTabContent>
          <app-manual-rate></app-manual-rate>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 6px; font-size: 20px; width: 20px; height: 20px;">show_chart</mat-icon>
          Binance
        </ng-template>
        <app-binance-rate [showCopyToClipboard]="true"></app-binance-rate>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon style="margin-right: 6px; font-size: 20px; width: 20px; height: 20px;">payments</mat-icon>
          CBPay
        </ng-template>
        <app-cbpay [showCopyToClipboard]="true"></app-cbpay>
      </mat-tab>
    </mat-tab-group>
  </div>

</div>
